import update from 'immutability-helper'
import { normalizeArray } from '../../lib/util'
import { RECV_ROOM } from '../actions/main'
import {
  SET_DISP_TEAMS, UPDATE_DISP_TEAMS, SET_DRAGGING_PLAYER
} from '../actions/teams'

export const initialState = {
  orig: [],
  disp: [],
  draggingPlayer: null
}

const recvRoom = (state, action) => {
  const room = action.room
  const teams = room.teams.map(team => ({
    id: team.id,
    name: team.name,
    players: normalizeArray(team.players)
  }))

  return update(state, {
    orig: { $set: teams },
    disp: { $set: teams }
  })
}

export const teamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECV_ROOM:
      return recvRoom(state, action)
    case SET_DISP_TEAMS:
      return update(state, {
        disp: { $set: action.teams }
      })
    case UPDATE_DISP_TEAMS:
      return update(state, {
        disp: { $set: Array.from(state.disp) }
      })
    case SET_DRAGGING_PLAYER:
      return update(state, {
        draggingPlayer: { $set: action.draggingPlayer }
      })
    default:
      return state
  }
}
